/**
 * @prop --vx-cart-font-color: The global font color.
 * @prop --vx-cart-max-width: The max width of the cart wrapper
 * @prop --vx-cart-button-background: The background color of the cart button.
 * @prop --vx-cart-border-color: The border color.
 * @prop --vx-cart-new-item-text-font-size: The font size of the new item text.
 * @prop --vx-cart-new-item-text-line-height: The line height of the new item text.
 * @prop --vx-cart-gross-amount-font-size: The font size of the cost difference text.
 * @prop --vx-cart-gross-amount-line-height: The line height of the cost difference text.
 * @prop --vx-cart-cost-difference-font-size: The font size of the cost difference text.
 * @prop --vx-cart-cost-difference-line-height: The line height of the cost difference text.
 * @prop --vx-cart-cost-difference-color: The color of the cost difference text.
 * @prop --vx-cart-button-top-space: The margin between the shipping costs and the cart button.
 * @prop --vx-cart-notification-color: The notification color.
 * @prop --vx-cart-top: The top value of the cart-overlay. default 100%.
 */
@keyframes blinker {
  0% {
    color: var(--vx-cart-cost-difference-color, #908787);
  }
  50% {
    color: var(--vx-cart-notification-color, #6ca422);
  }
  100% {
    color: var(--vx-cart-cost-difference-color, #908787);
  }
}
:host {
  color: var(--vx-cart-font-color, var(--mdc-theme-primary, #000));
  overflow: hidden;
  top: var(--vx-cart-top, 100%);
  width: 100vw;
  box-sizing: border-box;
}

@media screen and (min-width: 768px) {
  :host {
    width: var(--vx-cart-max-width, 375px);
    right: 0;
  }
}
.spacer, .summary .spacer {
  flex-grow: 1;
}

.notification-color {
  color: var(--vx-cart-notification-color, #6ca422);
}

.blink {
  text-decoration: blink;
  animation: blinker 2.5s ease-out alternate;
}

.wrapper {
  display: flex;
  flex-direction: column;
  opacity: inherit;
  height: inherit;
  max-width: none;
  padding: 16px;
}
@media screen and (min-width: 768px) {
  .wrapper {
    max-width: var(--vx-cart-max-width, 375px);
  }
}
.wrapper .new-item-notification {
  display: flex;
  overflow: hidden;
  transition: 0.1s ease-in-out;
  transition-property: max-height, margin;
  max-height: 0;
  height: 100%;
  width: 100%;
  border-bottom: 1px solid transparent;
}
.wrapper .new-item-notification-content {
  display: flex;
  padding-bottom: 8px;
  font-size: var(--vx-cart-new-item-font-size, 16px);
  line-height: var(--vx-cart-new-item-line-height, 20px);
  justify-content: start;
  align-items: center;
  gap: 16px;
}
.wrapper .new-item-notification-content .new-item-icon {
  --mdc-icon-size: var(--vx-cart-new-item-font-size, 16px);
  width: var(--vx-cart-new-item-font-size, 16px);
  height: var(--vx-cart-new-item-font-size, 16px);
}
.wrapper .summary {
  display: flex;
  font-size: var(--vx-cart-gross-amount-font-size, 16px);
}
.wrapper .summary .gross-amount-value {
  text-align: right;
}
.wrapper .shipping-costs-difference {
  font-size: var(--vx-cart-cost-difference-font-size, 12px);
  color: var(--vx-cart-cost-difference-color, #908787);
  text-align: left;
}
.wrapper vx-button {
  margin-top: 8px;
}
.wrapper vx-button:hover {
  --mdc-theme-primary: var(--mdc-theme-primary-background-color-hover, #ea5659);
}
.wrapper.has-new-item .new-item-notification {
  margin-bottom: 12px;
  transition: 0.2s ease-in-out;
  border-color: var(--vx-cart-border-color, #e5dfdf);
  max-height: 200px;
}